import { useMutation } from 'react-query'
import { config } from 'config'
import { callAxios, CustomAxiosError } from 'utils/api'

const { SECURE_BASE_URL } = config!

const acceptTnC = async (googleId: string): Promise<any> => {
  return callAxios({
    method: 'PATCH',
    url: `${SECURE_BASE_URL}/acceptTermsAndConditions`,
    data: {
      googleAccountId: googleId,
    },
  })
}

export const useAcceptTnC = () => {
  const {
    status: getAcceptTnCStatus,
    error: getAcceptTnCError,
    mutate: mutateAcceptTnC,
  } = useMutation<any, CustomAxiosError, string>(acceptTnC)

  return { getAcceptTnCStatus, getAcceptTnCError, mutateAcceptTnC }
}
